import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentComponent } from './components/content/content.component';
import { ItemTitleComponent } from './components/item-title/item-title.component';
import { ItemPaddingComponent } from './components/item-padding/item-padding.component';
import { ColumnComponent } from './components/column/column.component';
import { RowComponent } from './components/row/row.component';
import { ColumnItemComponent } from './components/column-item/column-item.component';
import { RowItemComponent } from './components/row-item/row-item.component';
import { LogoComponent } from './components/logo/logo.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { IonicModule } from '@ionic/angular';
import { PolicyStatusComponent } from './components/policy-status/policy-status.component';
import { BankComponent } from './components/icons/bank/bank.component';
import { CreditCardIconComponent } from './components/icons/credit-card-icon/credit-card-icon.component';
import { PolicyItemComponent } from './components/policy-item/policy-item.component';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { HeaderComponent } from './components/header/header/header.component';



@NgModule({
  declarations: [ContentComponent, ItemTitleComponent, ItemPaddingComponent, ColumnComponent, RowComponent, ColumnItemComponent, RowItemComponent, LogoComponent, SkeletonComponent, PolicyStatusComponent, BankComponent, CreditCardIconComponent,PolicyItemComponent, ErrorModalComponent, HeaderComponent],
  imports: [
    CommonModule, IonicModule
  ],
  exports: [ContentComponent, ItemTitleComponent, ItemPaddingComponent, ColumnComponent, RowComponent, ColumnItemComponent, RowItemComponent,  LogoComponent, SkeletonComponent,  PolicyStatusComponent,  BankComponent, CreditCardIconComponent, PolicyItemComponent, ErrorModalComponent, HeaderComponent]
})
export class CoreModule { }
